/**
 * Copyright © Veeam Software Group GmbH.
 */

import { JobTargetKindInteg } from '@veeam-vspc/models/web-controllers';

export type JobTargetKinds = JobTargetKindInteg;
export const JobTargetKinds = JobTargetKindInteg;
